import { Maybe } from '@passionware/monads';
import React from 'react';
import { WithServices } from 'v5/platform/ts/services';
import { WithGlobalSettingsService } from 'v5/services/internal/GlobalSettingsService/GlobalSettingsService';
import { NameWithPronouns } from './NameWithPronouns';

export interface ResourceNameWithPronounsProps
  extends WithServices<[WithGlobalSettingsService]> {
  /** Primary name (string or node). */
  name: React.ReactNode;
  pronounsOptionId: Maybe<number>;
  resourceTypeId: Maybe<number>;
  className?: string;
  /** Additional classes for the name segment (e.g. font weight). */
  nameClassName?: string;
}

/**
 * Renders resource name with optional pronouns; keeps pronouns visible (no clip) when space is tight.
 */
export function ResourceNameWithPronouns({
  name,
  pronounsOptionId,
  resourceTypeId,
  services,
  className,
  nameClassName
}: ResourceNameWithPronounsProps) {
  const pronouns = services
    ? services.globalSettingsService.usePronounsForResourceType(
        pronounsOptionId ?? null,
        resourceTypeId ?? null
      )
    : null;
  return (
    <NameWithPronouns
      name={name}
      pronouns={pronouns}
      className={className}
      nameClassName={nameClassName}
    />
  );
}
